
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PackageItem } from '@/features/shipment/types';
import { getPackageDetails } from '@/features/common/helpers';

@Component
export default class PackageDetails extends Vue {
  @Prop({ required: true }) packages!: PackageItem[];

  private getPackageDetails = getPackageDetails;
}
